// extracted by mini-css-extract-plugin
export default {"statusIcon":"styles__statusIcon___WUW8r","badge":"styles__badge___uTLMy","inner":"styles__inner___H7x66"};